/**
 * memoryStorage.ts
 * 简单的内存缓存，刷新页面即清空
 */

import sm2Util from './sm2Util'

interface Stored {
  data: string
  expire: number
}

const store: Record<string, Stored> = {}

export default {
  set(
    key: string,
    value: any,
    options: { expire?: number; encrypt?: boolean } = {}
  ) {
    const { expire = 0, encrypt = false } = options
    let str = typeof value === 'string' ? value : JSON.stringify(value)
    if (encrypt) {
      const enc = sm2Util.encrypt(str)
      if (!enc) return false
      str = enc
    }
    const expireAt = expire > 0 ? Date.now() + expire : 0
    store[key] = { data: str, expire: expireAt }
    return true
  },

  get(key: string, options: { encrypt?: boolean } = {}) {
    const { encrypt = false } = options
    const obj = store[key]
    if (!obj) return null
    if (obj.expire && obj.expire < Date.now()) {
      delete store[key]
      return null
    }
    let str = obj.data
    if (encrypt) {
      const dec = sm2Util.decrypt(str)
      if (dec === null) return null
      str = dec
    }
    try {
      return JSON.parse(str)
    } catch {
      return str
    }
  },

  remove(key: string) {
    delete store[key]
  },

  clear() {
    for (const k in store) delete store[k]
  }
}
